/**
 * A news date the way a reader scans it: "Oct 6" this year, "Oct 6, 2025"
 * for anything older. Takes an ISO timestamp.
 */
export function formatNewsDate(iso: string, now: Date = new Date()): string {
  const date = new Date(iso)
  const sameYear = date.getFullYear() === now.getFullYear()
  return date.toLocaleDateString(undefined, sameYear
    ? { month: 'short', day: 'numeric' }
    : { month: 'short', day: 'numeric', year: 'numeric' })
}
